import * as LoadingStatus from '@coconut/constants/loadingState';

export const types = {
  GET_INIT_CURRICULUMS_AND_SUBJECTS_REQUEST:
    'GET_INIT_CURRICULUMS_AND_SUBJECTS_REQUEST',
  GET_INIT_CURRICULUMS_AND_SUBJECTS_SUCCESS:
    'GET_INIT_CURRICULUMS_AND_SUBJECTS_SUCCESS',
  GET_INIT_CURRICULUMS_AND_SUBJECTS_FAILURE:
    'GET_INIT_CURRICULUMS_AND_SUBJECTS_FAILURE',
  GET_SUBJECTS_REQUEST: 'GET_SUBJECTS_REQUEST',
  GET_SUBJECTS_SUCCESS: 'GET_SUBJECTS_SUCCESS',
  GET_SUBJECTS_FAILURE: 'GET_SUBJECTS_FAILURE',
  SET_CURRICULUMID_AND_SUBJECTID: 'SET_CURRICULUMID_AND_SUBJECTID',
};

export const actions = {
  getInitialCurriculumsAndSubjects: () => ({
    type: types.GET_INIT_CURRICULUMS_AND_SUBJECTS_REQUEST,
  }),
  getInitialCurriculumsAndSubjectsSuccess: ({
    curriculums,
    nestedSubjects,
    subjects,
  }) => {
    const [defaultCurriculum] = curriculums;

    return {
      type: types.GET_INIT_CURRICULUMS_AND_SUBJECTS_SUCCESS,
      payload: {
        curriculums,
        defaultCurriculumId: defaultCurriculum.id,
        subjects,
        nestedSubjects,
        defaultSubjectIndex: -1,
      },
    };
  },
  getInitialCurriculumsAndSubjectsFail: () => ({
    type: types.GET_INIT_CURRICULUMS_AND_SUBJECTS_FAILURE,
  }),
  getSubjects: (curriculumId) => ({
    type: types.GET_SUBJECTS_REQUEST,
    curriculumId,
  }),
  getSubjectsSuccess: ({ nestedSubjects, subjects }) => ({
    type: types.GET_SUBJECTS_SUCCESS,
    payload: {
      subjects,
      nestedSubjects,
      defaultSubjectIndex: -1,
    },
  }),
  getSubjectsFail: () => ({ type: types.GET_SUBJECTS_FAILURE }),
  setCurriculumIdAndSubjectId: (curriculumId, subjectId) => ({
    type: types.SET_CURRICULUMID_AND_SUBJECTID,
    payload: {
      selectedSubjectId: subjectId,
      selectedCurriculumId: curriculumId,
    },
  }),
};

const initialState = {
  loadingStatus: LoadingStatus.EMPTY,
  curriculums: [],
  subjects: [],
  nestedSubjects: [],
  selectedSubjectIndex: -1,
  selectedSubjectId: 0,
  selectedCurriculumId: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_INIT_CURRICULUMS_AND_SUBJECTS_REQUEST:
      return {
        ...state,
        loadingStatus: LoadingStatus.LOADING,
      };
    case types.GET_INIT_CURRICULUMS_AND_SUBJECTS_SUCCESS:
      return {
        ...state,
        loadingStatus: LoadingStatus.READY,
        curriculums: action.payload.curriculums,
        subjects: action.payload.subjects,
        nestedSubjects: action.payload.nestedSubjects,
        selectedSubjectIndex: action.payload.defaultSubjectIndex,
        selectedCurriculumId: action.payload.defaultCurriculumId,
      };
    case types.GET_INIT_CURRICULUMS_AND_SUBJECTS_FAILURE:
      return {
        ...state,
        loadingStatus: LoadingStatus.ERROR,
      };
    case types.GET_SUBJECTS_REQUEST:
      return {
        ...state,
        loadingStatus: LoadingStatus.LOADING,
        selectedCurriculumId: action.curriculumId,
      };
    case types.GET_SUBJECTS_SUCCESS:
      return {
        ...state,
        loadingStatus: LoadingStatus.READY,
        subjects: action.payload.subjects,
        nestedSubjects: action.payload.nestedSubjects,
        selectedSubjectIndex: action.payload.defaultSubjectIndex,
      };
    case types.GET_SUBJECTS_FAILURE:
      return {
        ...state,
        loadingStatus: LoadingStatus.ERROR,
      };
    case types.SET_CURRICULUMID_AND_SUBJECTID:
      return {
        ...state,
        selectedSubjectId: action.payload.selectedSubjectId,
        selectedCurriculumId: action.payload.selectedCurriculumId,
      };
    default:
      return state;
  }
};

export default reducer;

export const getCurriculums = (state) => state.askQuestion.curriculums;
export const getSubjects = (state) => state.askQuestion.subjects;
export const getNestedSubjects = (state) => state.askQuestion.nestedSubjects;
export const getSelectedCurriculumId = (state) =>
  state.askQuestion.selectedCurriculumId;
export const getSelectedSubjectId = (state) =>
  state.askQuestion.selectedSubjectId;
export const getSelectedSubjectIndex = (state) =>
  state.askQuestion.selectedSubjectIndex;
export const getLoadingStatus = (state) => state.askQuestion.loadingStatus;
export const getSelectedCurriculum = (state) => {
  const [curriculum] = state.askQuestion.curriculums.filter(
    (c) => c.id === state.askQuestion.selectedCurriculumId
  );

  return curriculum || {};
};
export const getSelectedSubject = (state) => {
  const [subject] = state.askQuestion.subjects.filter(
    (c) => c.id === state.askQuestion.selectedSubjectId
  );

  return subject || {};
};

const addEnableKeyToSubjects = (subjects, enable = true) =>
  subjects.map((subject) => ({
    ...subject,
    enable,
  }));

export function combineSubjectData(rawData) {
  const { disabled_subjects, enabled_subjects } = rawData;
  return [
    ...addEnableKeyToSubjects(enabled_subjects),
    ...addEnableKeyToSubjects(disabled_subjects, false),
  ];
}



// WEBPACK FOOTER //
// ./src/services/redux/askQuestion.js